import React from "react";

const SubmissionError = () => (
  <h1 className="mt-5" style={{ textAlign: "center" }}>
    There was an error processing your request.
  </h1>
);

export { SubmissionError };